import { LitElement, html } from 'lit';
import './fit-slider';
import styles from './fit-thumbnail-slider.css';
import { BreakpointBehavior } from '../fit-style/fit-breakpoint-behavior';

class FitThumbnailSlider extends BreakpointBehavior(LitElement) {
  static get is() { return 'fit-thumbnail-slider'; }

  static get styles() { return styles; }

  render() {
    return html`
      <fit-slider class="slides" slides-per-frame="1" center-selected .index="${this.selected}" @fit-slider-selected-changed="${this.handleSelection}">
         <slot name="slides"></slot>
      </fit-slider>
      <fit-slider class="thumbnails" .index="${this.selected}" @fit-slider-selected-changed="${this.handleSelection}">
          <slot name="thumbnails"></slot>
      </fit-slider>
    `;
  }

  static get properties() {
    return {
      selected: {
        type: Number,
      },
    };
  }

  constructor() {
    super();
    this.selected = 0;
  }

  handleSelection(event) {
    if (event.detail !== this.selected) {
      this.selected = event.detail;
    }
  }
}

customElements.define(FitThumbnailSlider.is, FitThumbnailSlider);
